import { render, staticRenderFns } from "./ThemeFeatures.vue?vue&type=template&id=2a0b8b23"
import script from "./ThemeFeatures.vue?vue&type=script&lang=js"
export * from "./ThemeFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports